var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-editor",style:({ width: _vm.width })},[_c('canvas',{attrs:{"id":"c"}})])}
var staticRenderFns = []

export { render, staticRenderFns }